import React from 'react';
import { Typography as MuiTypography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  planName: {
    fontSize: '1.25rem',
    fontWeight: 800,
    color: theme.palette.text.primary,
    lineHeight: 1.2,
  },
  planPrice: {
    fontSize: '1rem',
    fontWeight: 700,
    display: 'flex',
    alignItems: 'baseline',
    gap: 4,
  },
  priceInterval: {
    fontSize: '0.75rem',
    color: theme.palette.text.secondary,
    fontWeight: 400,
  },
  cardTitle: {
    fontSize: '0.75rem',
    fontWeight: 600,
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    letterSpacing: '0.02em',
  },
  sectionTitle: {
    fontSize: '0.75rem',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    letterSpacing: '0.02em',
  },
  infoText: {
    fontSize: '0.8rem',
    color: theme.palette.text.secondary,
  },
  infoValue: {
    fontSize: '0.8rem',
    fontWeight: 600,
  },
  caption: {
    fontSize: '0.75rem',
    lineHeight: 1.4,
    color: theme.palette.text.secondary,
  }
}));

export const SKTypography = ({ variant = 'body1', subVariant, className = '', children, ...props }) => {
  const classes = useStyles();
  
  const typographyClasses = [
    subVariant && classes[subVariant],
    className
  ].filter(Boolean).join(' ');

  return (
    <MuiTypography 
      variant={variant} 
      className={typographyClasses}
      {...props}
    >
      {children}
    </MuiTypography>
  );
};
